import React from 'react';
import { createStyles, Divider, Grid, makeStyles } from '@material-ui/core';

import { ClientClipper } from '../ClientClipper/view/ClientClipper';
import { ClientContents } from '../ClientContents/view/ClientContents';
import { ClientContext } from '../ClientContext';
import { ClientCutout } from '../ClientCutout/view/ClientCutout';
import { ClientExtraParameter } from '../ClientExtraParameter/view/ClientExtraParameter';
import { ClientKeywords } from '../ClientKeyword/view/ClientKeywords';
import { ClientOrganogram } from '../ClientOrganogram/view/ClientOrganogram';
import { ClientSource } from '../ClientSource/view/ClientSource';
import { ClientVehicle } from '../ClientVehicle/view/ClientVehicle';
import { ClientPageTabs } from '../enums/ClientPageTabs';
import { TableEmpty } from '../../../shared/components/TableEmpty';
import { ClientAvatar } from '../ClientAvatar/view/ClientAvatar';
import { ClientColor } from '../ClientColor/view/ClientColor';
import { ClientSocialMedia } from '../ClientSocialMedia/views/ClientSocialMedia';
import { ClientStockSymbol } from '../ClientStockSymbol/views/ClientStockSymbol';
import { ShowInitialPageCheckbox } from '../ClientDashboardInitialPage/components/ShowInitialPageCheckbox';

const useStyles = makeStyles((theme) => createStyles({
    pages: {
        marginBottom: theme.spacing(3),
    },
}));
export interface IShowDialogProps {
    showDialog: boolean,
    setShowDialog: (showDialog: boolean) => void
}

export function ClientPages() { 
    const classes = useStyles();

    const clientContext = React.useContext(ClientContext);  
    
    return (
        <> 
            {clientContext.clientPage === ClientPageTabs.ORGANOGRAM_CUTOUT && (
                <>
                    <Grid item xs={12} className={classes.pages}><ClientOrganogram/></Grid>
                    <Grid item xs={12}><ClientCutout/></Grid>
                </>
            )}
            {clientContext.clientPage === ClientPageTabs.NEWS_ORIGIN && (
                <>
                    <Grid item xs={12} className={classes.pages}><ClientVehicle/></Grid>
                    <Grid item xs={12} className={classes.pages}><ClientSource/></Grid>
                    <Grid item xs={12}><ClientClipper/></Grid> 
                </>
            )}
            {clientContext.clientPage === ClientPageTabs.TAGS && (
                <>
                    <Grid item xs={12} className={classes.pages}><ClientKeywords/></Grid>
                    <Grid item xs={12} className={classes.pages}><ClientExtraParameter/></Grid>
                    <Grid item xs={12}><ClientContents /></Grid>
                </>
            )}
            {clientContext.clientPage === ClientPageTabs.DASHBOARD && (
                <>
                    <Grid item className={classes.pages}><ClientAvatar/></Grid>
                    <Divider orientation="vertical" flexItem variant="middle"/>
                    <Grid item>
                        <Grid container direction="column" spacing={3}>
                            <Grid item><ClientColor /></Grid>
                            <Grid item><ShowInitialPageCheckbox /></Grid>
                        </Grid>
                    </Grid>
                    <Divider orientation="vertical" flexItem variant="middle"/>
                    <Grid item><ClientStockSymbol /></Grid>
                </>
            )}
            {clientContext.clientPage === ClientPageTabs.SOCIAL_MEDIA && (
                <>
                    <Grid item xs={12}><ClientSocialMedia /></Grid>
                </>
            )}
            {clientContext.clientPage === ClientPageTabs.DEFAULT && (
                <TableEmpty 
                    displayText={`Selecione uma das abas para iniciar ${!clientContext.editMode ? 'o cadastro': 'a edição'} do cliente.`}
                    cssProperties={{ 
                        minHeight: '150px',
                    }} /> 
            )}
        </>
    );
}